import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";

import dateMixin from "./dateMixin";

const day = event => {
  return dateMixin.methods.convertDateObject(event.starts_at, "DD/MM");
};

const weekday = event => {
  return dateMixin.filters.weekday(event.starts_at);
};

const period = event => {
  return orderSchedulerHelper.scheduleEventPeriod(event);
};

export default {
  filters: {
    day,
    weekday,
    period
  }
};



// WEBPACK FOOTER //
// ./src/mixins/scheduleEventMixin.js